/* eslint-disable react-refresh/only-export-components */
import { withSuspense } from '@/modules/global-components/ui/suspense/withSuspense';
import { lazy } from 'react';
import { Navigate } from 'react-router';

const PrivateViewInvoice = lazy(
  () =>
    import('@/modules/export/shipping/invoices/components/components/preview-invoice/PrivateViewInvoice'),
);

const Invoices = lazy(
  () => import('@/modules/export/shipping/invoices/Invoices'),
);

const AddShipment = lazy(
  () => import('@/modules/export/shipping/add/AddShipmentBooking'),
);
const AddInspection = lazy(
  () => import('@/modules/export/inspection/add/AddInspection'),
);
const EditInspection = lazy(
  () => import('@/modules/export/inspection/edit/EditInspection'),
);
const ListInspection = lazy(
  () => import('@/modules/export/inspection/list/ListInspection'),
);
const ViewInspection = lazy(
  () => import('@/modules/export/inspection/view/ViewInspection'),
);
const AddTransportation = lazy(
  () => import('@/modules/export/transportation/add/AddTransportation'),
);
const EditTransportation = lazy(
  () => import('@/modules/export/transportation/edit/EditTransportation'),
);
const ListTransportation = lazy(
  () => import('@/modules/export/transportation/list/ListTransportation'),
);
const ViewTransportation = lazy(
  () => import('@/modules/export/transportation/view/ViewTransportation'),
);
const ShippableCarriers = lazy(
  () => import('@/modules/export/inspection/shippable/ShippableCarriers'),
);
const ListShipping = lazy(
  () => import('@/modules/export/shipping/list/ListShipping'),
);
const ViewShipping = lazy(
  () => import('@/modules/export/shipping/view/ViewShipping'),
);
const EditShipping = lazy(
  () => import('@/modules/export/shipping/edit/EditShipping'),
);
const ListAuction = lazy(
  () => import('@/modules/export/auction/list/ListAuction'),
);

export const exportRoutes = [
  {
    path: 'auction',
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: withSuspense(ListAuction),
      },
    ],
  },
  {
    path: 'transportation',
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />,
      },
      {
        path: 'add',
        element: withSuspense(AddTransportation),
      },
      {
        path: 'list',
        element: withSuspense(ListTransportation),
      },
      {
        path: ':transport_id/edit',
        element: withSuspense(EditTransportation),
      },
      {
        path: ':transport_id/view',
        element: withSuspense(ViewTransportation),
      },
    ],
  },
  {
    path: 'inspection',
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />,
      },
      {
        path: 'add',
        element: withSuspense(AddInspection),
      },
      {
        path: 'list',
        element: withSuspense(ListInspection),
      },
      {
        path: ':insp_id/edit',
        element: withSuspense(EditInspection),
      },
      {
        path: ':insp_id/view',
        element: withSuspense(ViewInspection),
      },
      {
        path: 'approve',
        element: withSuspense(ShippableCarriers),
      },
    ],
  },
  {
    path: 'shipping',
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />,
      },
      {
        path: 'add',
        element: withSuspense(AddShipment),
      },
      {
        path: 'list',
        element: withSuspense(ListShipping),
      },
      {
        path: ':id/edit',
        element: withSuspense(EditShipping),
      },
      {
        path: ':id/view',
        element: withSuspense(ViewShipping),
      },

      // invoice routing
      {
        path: ':id/invoice',
        children: [
          {
            path: 'instructions',
            element: withSuspense(() => <Invoices type="instructions" />),
          },
          {
            path: 'ship',
            element: withSuspense(() => <Invoices type="invoice" />),

            children: [
              {
                path: ':invoiceId/proforma',
                element: withSuspense(() => <Invoices type="invoice" />),
              },
            ],
          },
        ],
      },

      {
        path: 'invoice',
        children: [
          {
            path: 'view',
            element: withSuspense(PrivateViewInvoice),
          },
        ],
      },
    ],
  },
];
